export default "__VITE_ASSET__DhC4jPDc__"